import React from 'react'

import './footer.css'
import {useTranslation} from "react-i18next";


const Footer = ({footerMenuItems}) => {
    const {t} = useTranslation();
    return (
        <footer className="footer-footer">
            <div className="footer-container1">
                <div className="footer-container2">
                    <span className="footer-text10 Large">Louis Nguyen</span>
                    <span className={"Large"}>Copyright © 2025 Louis Nguyen.</span>
                </div>
                <div className="footer-menu-item-container">
                    <div className="footer-menu-item-sub-container">
                        <span className={"footer-menu-item-title Large"}>{t("footer_footer-menu-item-title")}</span>
                        {footerMenuItems}
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
